<template>
  <component
    :is="props.item"
    class="iconClass"
    size="20"
    stroke-width="1.5" />
</template>

<script lang="ts" setup>
const props = defineProps({ item: Object });
</script>
